import React, { useState} from 'react';
import styled from "styled-components"
import mainbg from "../assets/mainbg2.png"
import rightArrow from "../assets/rightarrow.svg"
import arrow from "../assets/arriow.svg";
import close from "../assets/close.svg";






export const Wrapper = styled.div`
  width:100%;
  height: 100vh;
  min-height: 800px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: url(${mainbg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding:50rem 0;
  overflow: hidden;
  
  @media (min-width: 450px) {
        height: 150vh;
    }
  
   @media (min-width: 650px) {
   height: 110vh;

    }
  
   @media (min-width: 850px) {
   padding:0;
    height: 100vh;

    }
  
  h1 {
      font-size: 4rem;
          
            @media (min-width: 700px) {
            font-size: 6rem;
          }
  }
  

`
export const Heading = styled.h3`
font-size: 5rem;
color:#AB5EB2;
`
export const ButtonsContainer = styled.div`
display: grid;
 grid-template-columns: 75px 75px 80px;
 grid-template-rows: 35px 35px;
 grid-gap: 8px;
 position:absolute;
 right: 0;
 
  @media (min-width: 550px) {
      grid-template-columns: 75px 75px 160px;
    }
 
  @media (min-width: 780px) {
     right: 50px;
    }
`

export const StakeInput = styled.input`
max-width: 1000px;
width:100%;
margin:0 auto;
border:4px solid #964B9D;
height: 100px;
min-height: 100px;
border-radius: 5px;
background: rgba(255,255,255,0.4);
font-size: 4rem;
color:#964B9D;
padding:0 3rem;
font-family: 'PT Sans Narrow', sans-serif;
min-width: 380px;



&::placeholder {
color:#DF8DE7;
}

&:focus{
outline: none;
}
`


export const InputContainer = styled.div`
display: flex;
justify-content: center;
align-items: center;
color:#964B9D;
font-size: 4rem;
max-width: 1000px;
width:95%;
position:relative;
top:50px;
transform: scale(0.8);
min-width: 380px;
margin-bottom: 4rem;
min-height: 100px;

  @media (min-width: 430px) {
  transform: none;
    }

 @media (min-width: 780px) {
      width:80%;
      padding:0 5rem;

    }
    
  @media (min-width: 1470px) {
       top:initial;
       width:100%;

    }
    

`

export const CryptoValue = styled.div   `
    position:absolute;
    left:50%;
    top:-70px;
    transform: translateX(-50%);
    color:#964B9D;
    font-size: 5rem;

@media (min-width: 780px) {
        left:-70px;
        top:50%;
        transform: translateY(-50%);
    }
`

export const SmallButton = styled.button`
background: #AB5EB2;
border:  none;
box-shadow: -1px 2px 0 1px #BD86C2;
border-radius: 3px;
width:75px;
height: 35px;
color:#fff;
font-family: Montserrat, sans-serif;
font-weight: 300;
font-size: 2rem;
transition: .1s all ease-in-out;

&:hover {
cursor: pointer;
transform: translate(-1px,1px);
box-shadow: 0 0 0 1px #BD86C2;
transition: .1s all ease-in-out;
}


&:focus{
outline: none;
}
`


export const LargeButton = styled.button`
background: #AB5EB2;
border:  none;
box-shadow: -1px 2px 0 1px #BD86C2;
border-radius: 3px;
width:70px;
height: 78px;
color:#fff;
font-family: Montserrat, sans-serif;
font-weight: 300;
font-size: 2rem;
display: flex;
justify-content: center;
align-items: center;
transition: .1s all ease-in-out;

 @media (min-width: 550px) {
 width:150px;
    }

&:hover {
cursor: pointer;
transform: translate(-1px,1px);
box-shadow: 0 0 0 1px #BD86C2;
transition: .1s all ease-in-out;
}

&:focus{
outline: none;

}
`


export const MinValue = styled.span`
position:absolute;
bottom: -30px;
left:15px;
color:#AB5EB2;
font-size: 2rem;

 @media (min-width: 780px) {
     left:65px;

    }
`


export const DepositButton = styled.button`
background: #fff;
border:2px solid #AB5EB2;
color:#AB5EB2;
font-size: 2.3rem;
font-family: 'PT Sans Narrow', sans-serif;
border-radius: 5px;
position:absolute;
bottom: -50px;
right:10px;
width:120px;
transition: .3s all ease-in-out;

 @media (min-width: 780px) {
      right:70px;
    }


&:hover {
cursor: pointer;
transform: scale(1.03);
transition: .3s all ease-in-out;
}

&:focus {
outline: none;
}
`

export const InfoContainer = styled.div`
width:90%;
margin:0 auto;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
margin-top: 15rem;

 @media (min-width: 630px) {
     flex-direction: row;
     justify-content: ${({secondary}) => secondary? "center" : "space-between"};

    }

 @media (min-width: 900px) {
   width:70%;

    }

 @media (min-width: 1400px) {
   width:50%;

    }
`

export const Box = styled.div`
background: #AB5EB2;
box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.42);
width: 250px;
height: 120px;
min-height: 120px;
border-radius: 10px;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
margin-bottom: 3rem;
 @media (min-width: 630px) {
  margin: 0;

    }
`

export const BoxTitle = styled.div`
color:#fff;
font-size: 2rem;
font-family: Montserrat;
font-weight: 300;
margin-bottom: 1rem;
`

export const BoxValue = styled.div`
color:#fff;
font-size: 3rem;
font-family: Montserrat;
font-weight: 300;
`

export const DepositModal = styled.div`
width:300px;
background: #f9f9f9;
display: ${({isModalOpen}) => isModalOpen? "flex" : "none"};
padding: 3rem 0;
flex-direction: column;
border: 3px solid rgba(171,94,178,0.45);
border-radius: 5px;
padding:2rem;
position:fixed;
overflow: hidden;
height: 500px;
left:50%;
top:50%;
transform: translate(-50%,-50%);
`


export const DepositTitle = styled.h3`
  color:#AB5EB2;
  font-size: 3rem;
`

export const Select = styled.button`
border:2px solid #AB5EB2;
height: 50px;
border-radius:2px;
padding: 0 1rem;
color:#ca70d2;
font-family: 'PT Sans Narrow', sans-serif;
font-size: 1.8rem;
background: transparent;
display: flex;
justify-content: space-between;
align-items: center;

&:hover {
cursor: pointer;
}

&:focus {
outline: none;
}
`

export const Close = styled.img`
  width:15px;
  height: 15px;
  position:absolute;
  right: 10px;
  top:10px;
  z-index: 999;
  &:hover {
  cursor: pointer;
  }
`

export const OptionsContainer = styled.div`
position:absolute;
width:90%;
height: 270px;
background: #fff;
bottom: ${({isCloseBtnActive}) => isCloseBtnActive? "0" : "-280px"};
left:50%;
transform: translateX(-50%);
border-radius: 5px 5px 0 0;
box-shadow: 0 0 10px -7px #212121;
padding-top: 3rem;
transition: .3s all ease-in-out;
`

export const OptionItem = styled.div`
  width:90%;
  height: 40px;
  box-shadow: 0 0 10px -6px #212121;
  padding:0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin:2rem auto;
  font-weight: bold;
  
  &:hover {
    cursor: pointer;
    opacity: .8;
   background: #fdfdfd;
  }
  
  img {
  transform: rotate(-90deg);
  }
`

export const Label = styled.label`
color:#AB5EB2;
font-size: 2rem;
margin: 1rem 0;
`

export const Amount = styled.input`
font-family: 'PT Sans Narrow', sans-serif;
border:2px solid #AB5EB2;
height: 50px;
border-radius:2px;
padding: 0 1rem;
color:#ca70d2;
font-size: 1.8rem;

&::placeholder {
color:#d779e0;

}

&:focus {
outline: none;
}
`

export const BuyButton = styled.button`
  width:90%;
  margin:0 auto;
  height: 50px;
  border:none;
  border-radius: 5px;
 background-image: linear-gradient(to right, #9D50BB 0%, #6E48AA  51%, #9D50BB  100%);
 background-size: 200% auto;
 transition: 0.5s;
  font-family: 'PT Sans Narrow', sans-serif;
  color:#fff;
  font-size: 2.5rem;
  margin-top: auto;
  margin-bottom: 1rem;
  
  &:hover {
  cursor: pointer;
    background-position: right center; /* change the direction of the change here */
    text-decoration: none;
  }
   
   &:focus {
   outline: none;
   }
`

export const CancelButton = styled.button`
background: none;
border: none;
color:#ff6462;
margin:0 auto;
font-size: 1.8rem;
font-family: 'PT Sans Narrow', sans-serif;
position:relative;


  &:hover {
  cursor: pointer;
  }
  
   &:focus {
   outline: none;
   }
`
const Staking = () => {

    const [isCloseBtnActive, setCloseBtnActive] = useState(false)
    const [isModalOpen, setModalOpen] = useState(false)

    return (
        <Wrapper>

                <Heading >Stake Amount</Heading>
            <InputContainer >
                <CryptoValue>AMB</CryptoValue>
                <StakeInput placeholder="0.000" />
                <ButtonsContainer>
                    <SmallButton>
                        25%
                    </SmallButton>
                    <SmallButton>
                        50%
                    </SmallButton>
                    <LargeButton>
                        <img src={rightArrow} alt="arrow"/>
                    </LargeButton>
                    <SmallButton>
                        75%
                    </SmallButton>
                    <SmallButton>
                        100%
                    </SmallButton>

                </ButtonsContainer>
                <MinValue>Min. Stake: 1 AMB</MinValue>
                <DepositButton onClick={() => setModalOpen(!isModalOpen)}>Deposit</DepositButton>
            </InputContainer>

            <InfoContainer>
                <Box >
                    <BoxTitle>Estimated APR</BoxTitle>
                    <BoxValue>66.6%</BoxValue>
                </Box>

                <Box>
                    <BoxTitle>Daily Rewards</BoxTitle>
                    <BoxValue>8 AMB</BoxValue>
                </Box>
            </InfoContainer>


            <DepositModal isModalOpen={isModalOpen}>
                <DepositTitle>Buy Crypto</DepositTitle>
                <Label>Currency</Label>
                <Select  onClick={() => setCloseBtnActive(!isCloseBtnActive)}>
                    Ambient
                    <OptionsContainer isCloseBtnActive={isCloseBtnActive} >
                        <Close src={close} alt=""  onClick={() => setCloseBtnActive(!isCloseBtnActive)}/>
                        <OptionItem>Ambient <img src={arrow} alt="arrow"/></OptionItem>
                    </OptionsContainer>
                    <img src={arrow} alt=""/>
                </Select>
                <Label>Amount</Label>
                <Amount placeholder="24 000"/>
                <BuyButton> Buy Now</BuyButton>
                <CancelButton onClick={() => setModalOpen(!isModalOpen)}>Cancel</CancelButton>
            </DepositModal>
        </Wrapper>
    );
};

export default Staking;